import React from 'react'
import { Box, Center, Spinner } from '@chakra-ui/react'

import { useTeamChatConversation } from '../provider'
import TeamChatMessageContent from './message-content'
import { scrollbarCSS } from '~components/dashboard/action-item-list'
import FetchMoreWrapper from '~components/shared/wrappers/fetch-more-wrapper'

export default function TeamChatMessageList() {
    const { messages, networkStatus, fetchMore, hasMoreMessages } =
        useTeamChatConversation()

    return (
        <FetchMoreWrapper
            w="100%"
            flex={1}
            minH={0}
            overflowY="auto"
            overflowX="hidden"
            position="relative"
            overflowWrap="anywhere"
            pb={2}
            hasMore={hasMoreMessages}
            fetchMore={fetchMore}
            networkStatus={networkStatus}
            inverted
        >
            {networkStatus === 1 ? (
                <Center h="100%">
                    <Spinner size="xl" color="brand.500" />
                </Center>
            ) : (
                <Box>
                    {[...messages].reverse().map((message, index) => (
                        <TeamChatMessageContent
                            key={message.id}
                            message={message}
                            messageIndex={index}
                            allMessages={[...messages].reverse()}
                        />
                    ))}
                </Box>
            )}
        </FetchMoreWrapper>
    )
}
